import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboardTeacher,
  faBriefcase,
  faUsers,
  faLightbulb,
  faBuilding,
  faHandshake,
  faMoneyBillTransfer,
  faCashRegister,
  faMoneyBill1,
  faMagnet,
} from "@fortawesome/free-solid-svg-icons";
import { ContactBtn } from "../components/ContactBtn";

const BusinessConsultancyPage = () => {
  const serviceData = [
    {
      icon: faChalkboardTeacher,
      percentage: "95%",
      service: "Joint Venture",
      desc: "A Joint Venture is a business arrangement where two or more parties collaborate, pooling resources to achieve common objectives and share profits.",
      duration: "Ongoing support",
    },
    {
      icon: faBriefcase,
      percentage: "85%",
      service: "Industry Consulting",
      desc: "We provide actionable insights to streamline your operations and enhance your business processes.",
      duration: "3-6 months",
    },
    {
      icon: faUsers,
      percentage: "90%",
      service: "Human Capital Management",
      desc: "Strengthen your team with our customized leadership and team-building programs to foster collaboration.",
      duration: "Workshops & ongoing support",
    },
    {
      icon: faMagnet,
      percentage: "88%",
      service: "Machinery Supplier Consulting",
      desc: "Get guidance on leveraging cutting-edge technologies to boost innovation and create competitive advantages.",
      duration: "Project-based",
    },
    {
      icon: faMoneyBill1,
      percentage: "88%",
      service: "Investment Advice",
      desc: "Get guidance on leveraging cutting-edge technologies to boost innovation and create competitive advantages.",
      duration: "Project-based",
    },
    {
      icon: faCashRegister,
      percentage: "88%",
      service: "Budgeting and Forecasting",
      desc: "Get guidance on leveraging cutting-edge technologies to boost innovation and create competitive advantages.",
      duration: "Project-based",
    },
    {
      icon: faMoneyBillTransfer,
      percentage: "88%",
      service: "Tax Strategy",
      desc: "Get guidance on leveraging cutting-edge technologies to boost innovation and create competitive advantages.",
      duration: "Project-based",
    },
    {
      icon: faHandshake,
      percentage: "88%",
      service: "Mergers and Acquisitions",
      desc: "Get guidance on leveraging cutting-edge technologies to boost innovation and create competitive advantages.",
      duration: "Project-based",
    },
    {
      icon: faBuilding,
      percentage: "88%",
      service: "Real Estate Consulting",
      desc: "Get guidance on leveraging cutting-edge technologies to boost innovation and create competitive advantages.",
      duration: "Project-based",
    },
  ];

  // InvestmentCard Component
  const InvestmentCard = ({ title, description }) => (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-xl font-semibold text-red-500">{title}</h3>
      <p className="text-gray-700 mt-4">{description}</p>
    </div>
  );

  // Investment Data Array
  const investmentOptions = [
    {
      title: "Mutual Funds",
      description:
        "Diversify your portfolio with professionally managed mutual funds for long-term financial growth.",
    },
    {
      title: "Fixed Deposits",
      description:
        "Secure your savings with fixed deposits offering guaranteed returns and flexible tenures.",
    },
    {
      title: "Real Estate",
      description:
        "Explore real estate investments for stable and long-term returns with capital appreciation.",
    },
    {
      title: "Retirement Plans",
      description:
        "Plan your golden years with retirement plans designed for financial security and peace of mind.",
    },
    {
      title: "Gold Investments",
      description:
        "Invest in gold for portfolio diversification and a hedge against market volatility.",
    },
    {
      title: "Investment Solutions",
      description:
        "Investment Solutions offer strategies and products to help individuals or businesses grow wealth through diverse financial instruments and assets.",
    },
    {
      title: "Demat Accounts",
      description:
        "A Demat Account stores securities electronically, enabling investors to buy, sell, and transfer shares without physical certificates.",
    },
  ];

  return (
    <div className="bg-gray-50 text-gray-800 min-h-screen">
      <main className="container mx-auto py-12 space-y-12">
        {/* Introduction Section */}

        <section className="bg-red-600 text-white text-center py-16 pt-20">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Why Invest with Us?
          </h1>
          <p className="text-lg m-auto mb-6 max-w-[900px] ">
            we provide expert guidance and diverse investment options to help
            you achieve your financial goals. Whether you're a seasoned investor
            or just starting, we have the right solution for you.
          </p>
          <ContactBtn label={"Start Investing"} />
        </section>

        {/* Available Investments Section */}
        <section>
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Our Investment Options
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {investmentOptions.map((investment, index) => (
              <InvestmentCard
                key={index}
                title={investment.title}
                description={investment.description}
              />
            ))}
          </div>
        </section>

        {/* Hero Section */}
        <section className="bg-red-600 text-white text-center py-16 pt-20">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Business Consultancy Services
          </h1>
          <p className="text-lg mb-6">
            Transform your business with expert consulting services that drive
            success and growth.
          </p>
          <ContactBtn label={"Get Your Free Consultation"} />
        </section>

        {/* Our Services Section */}
        <section className="container mx-auto px-6 py-12 space-y-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Our Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {serviceData.map((service, index) => (
              <div
                key={index}
                className="bg-white text-gray-700 rounded-lg shadow-lg p-6 text-center transform hover:scale-105 transition-all"
              >
                <div className="flex items-center justify-center mb-4">
                  <FontAwesomeIcon
                    icon={service.icon}
                    className="text-red-600 w-12 h-12"
                  />
                </div>
                <h3 className="text-2xl font-semibold text-gray-900">
                  {service.service}
                </h3>
                <p className="mt-4 text-lg text-gray-600">{service.desc}</p>
                <p className="mt-2 text-sm font-medium text-gray-500">
                  {service.duration}
                </p>
                {/* <p className="mt-2 text-xl font-bold text-gray-800">{service.percentage}</p> */}
              </div>
            ))}
          </div>
        </section>
        {/* Call to Action Section */}
        <section className="bg-red-600 text-white rounded-lg shadow-lg p-8 text-center m-10 ">
          <h2 className="text-3xl font-bold mb-4">
            Let's Grow Your Business Together
          </h2>
          <p className="text-lg leading-relaxed mb-6">
            Ready to take your business to the next level? Our expert
            consultants are here to guide you every step of the way.
          </p>

          <ContactBtn label={"  Get Started Today"} />
        </section>
      </main>
    </div>
  );
};

export default BusinessConsultancyPage;
